import { RecordQ } from "@pdfking/structs"

import type { Margins } from "#public"

/** Margins as given, or the same margin on every edge. */
export const ToMargins = <T>(value: T | Margins<T>): Margins<T> =>
  RecordQ(value)
    ? value
    : {
        top: value,
        right: value,
        bottom: value,
        left: value,
      }
